import { Component, Host, h, Prop } from '@stencil/core';

@Component({
    tag: 'sew-ws-search-suggestions',
    styleUrl: 'sew-ws-search-suggestions.scss',
    shadow: false,
})
export class SewWsSearchSuggestions {
    @Prop() headline: string;

    render() {
        return (
            <Host>
                <div class="main-content-container">
                    <div>
                        <h2 class="headline" innerHTML={this.headline}></h2>
                        <div class="items">
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </Host>
        );
    }
}
